/**
 * @author Mathieu Chantot <mathieu.chantot@hes-so.ch>
 * @date 01/24
 */

//import 'react-range-slider-input/dist/style.css';
import React, { useEffect, useState } from "react";
import Slider from "./Slide.js";
import "./PathDrawing.css";

function DrawPath({
  drawingMode,
  moveState,
  drawState,
  prerecorded,
  validation,
  smoothDistance,
  setSmoothDistance,
  isComputed,
  sendTrajectory,
  erase,
}) {
  const [moveColor, setMoveColor] = useState("lightgrey");
  const [prerecordedColor, setPrerecordedColor] = useState("white");
  const [dotColor, setDotColor] = useState("white");
  const [lineColor, setLineColor] = useState("white");
  const [validationColor, setValidationColor] = useState("white");
  const activeColor = "rgba(207, 207, 207, 0.527)";
  const inactiveColor = "rgba(0,0,0,0.4)";

  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    setLineColor(inactiveColor);
    setDotColor(inactiveColor);
    setMoveColor(inactiveColor);
    setPrerecordedColor(inactiveColor);
    setValidationColor(inactiveColor);
    if (drawingMode === "dot") {
      setDotColor(activeColor);
    }
    if (drawingMode === "line") {
      setLineColor(activeColor);
    }
    if (drawingMode === "move") {
      setMoveColor(activeColor);
    }
    if (drawingMode === "validation") {
      setValidationColor(activeColor);
    }
    if (drawingMode === "prerecorded") {
      setPrerecordedColor(activeColor);
    }
  }, [drawingMode]);

  function computeAndSend() {
    validation();
    //sendTrajectory();
  }

  function toggleMenu() {
    setShowMenu(!showMenu);
    // console.log(showMenu);
  }

  /*
				<div id="send" className="element">
				<button style={{backgroundColor: validationColor}} onClick={() => sendTrajectory()} disabled={!isComputed}>
					Send
				</button>
			</div>
	*/

  return (
    <div id="main-menu">
      <div className="title">
        <p id="title">Menu</p>
        <p className="dropdown" onClick={toggleMenu}>
          ☰
        </p>
      </div>
      <div id="menu" className={showMenu ? "show" : "hide"}>
        <div className="element">
          <button id="move" style={{ backgroundColor: moveColor }} onClick={() => moveState()}>
            Move Map
          </button>
        </div>
        <div id="mode" className="element">
          <p>Drawing Mode</p>
          <button id="dot" style={{ backgroundColor: dotColor }} onClick={() => drawState("dot")}>
            Dot
          </button>
          <button
            id="line"
            style={{ backgroundColor: lineColor }}
            onClick={() => drawState("line")}
          >
            Line
          </button>
        </div>

        <div id="slider" className="element">
          <div className="input">
            <label>Smoothness: {smoothDistance}</label>
            <Slider setSmoothDistance={setSmoothDistance} />
          </div>
        </div>
        <div id="prerecorded" className="element">
          <button className="prerecorded" onClick={() => prerecorded()}>
            Prerecorded Path
          </button>
        </div>
        <div id="validate" className="element">
          <button className="validate" onClick={() => computeAndSend()}>
            Compute & Send
          </button>
        </div>

        <div id="delete" className="element">
          <button className="delete" onClick={() => erase()}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DrawPath;
